import PropTypes from "prop-types"
// Styles
import { Container, Wrapper } from "./ScrollButton.styles"
import { ExpandMore, ExpandLess } from "@mui/icons-material"

const ScrollButton = ({ orientation, scrollContainer }) => {
   const handleClick = () => {
      if (!scrollContainer) return
      const scrollAmount = window.innerHeight
      scrollContainer.scrollBy({
         top: orientation === "up" ? -scrollAmount : scrollAmount,
         behavior: "smooth",
      })
   }

   return (
      <Container onClick={handleClick}>
         <Wrapper>
            {orientation === "up" ? (
               <ExpandLess fontSize="Large" />
            ) : (
               <ExpandMore fontSize="Large" />
            )}
         </Wrapper>
      </Container>
   )
}

ScrollButton.propTypes = {
   orientation: PropTypes.string,
   scrollContainer: PropTypes.object,
}

export default ScrollButton
